"use client";
import { Box, IconButton } from "@radix-ui/themes";
import SVGIcon from "../assets/Icons";
import React from "react";

interface IconProps {
  iconName: string;
  handleAction(): void;
}

const PasswordViewIcon: React.FC<IconProps> = (props) => {
  return (
    <IconButton
      size="1"
      variant="ghost"
      className=" !text-secondary-default !mr-1 opacity-60 !cursor-pointer rounded-full"
      onClick={() => props?.handleAction()}
      aria-label={props.iconName === 'eyeIcon' ? 'Show password' : 'Hide password'}
      role="button"
    >
      <Box>
        <SVGIcon name={props.iconName} />
      </Box>
    </IconButton>
  );
};

export default PasswordViewIcon;
